// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pm-summary-edit-page[data-v-6e98ab3e] {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 4px 0;\n}\n.pm-summary-edit-page .page-header[data-v-6e98ab3e] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.pm-summary-edit-page .page-header .page-title[data-v-6e98ab3e] {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}", ""]);
// Exports
module.exports = exports;
